import log from 'loglevel';
import React, { useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { Events, ShortcutAction } from '../../types/player';
import ControlButton from '../ui/ControlButton';
import Shortcuts from '../../utils/Shortcut';

const Fullscreen = () => {
  const { sdk } = usePlayerContext();

  const [fullscreenState, setFullscreenState] = useState(false);

  useEffect(() => {
    sdk.on(Events.FULLSCREEN_CHANGED, (fullscreen: boolean) => {
      log.debug('fullscreenState', 'State changed', fullscreen);
      setFullscreenState(fullscreen);
    });
  }, []);

  function toggle() {
    sdk.toggleFullScreen();
  }

  const prefix = sdk.getClassNamePrefix();

  let short = sdk.options().getShortCut(ShortcutAction.FULLSCREEN);
  if (short) {
    Shortcuts([
      {
        key: short.key ?? '',
        action: toggle,
        altKey: short.altKey,
        shiftKey: short.shiftKey,
        ctrlKey: short.ctrlKey,
      },
    ]);
  }

  return (
    <div
      className={`${prefix}-player-control ${sdk.getClassNamePrefix()}-player-control-fullscreen ${fullscreenState ? `${prefix}-player-control-fullscreen-exit` : ''}`}
    >
      <ControlButton
        className={'fullscreen'}
        icon={fullscreenState ? 'compress' : 'expand'}
        handleAction={toggle}
        title={fullscreenState ? 'Exit fullscreen' : 'Fullscreen'}
      />
    </div>
  );
};

export default Fullscreen;
